<template>
	<div class="container">
		<el-breadcrumb separator=">" style="margin-bottom: 15px;">
			<el-breadcrumb-item :to="{ path: '/home' }">
				<div style="display: flex;align-items: center;margin-left: 15px;">
					<el-icon>
						<Location />
					</el-icon>
					<span style="margin-left: 5px;">首页</span>
				</div>
			</el-breadcrumb-item>
			<el-breadcrumb-item>{{categoryInfo.name}}</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="content">
			<div class="left">
				<div class="left-title">{{categoryInfo.name}}</div>
				<ul class="left-nav">
					<li class="left-nav-item" v-for="(item,num) in categoryInfo.children" :class="{active:index == num}"
						@click="navHandler(num)">{{item.name}}
						<div class="left-nav-flower"></div>
					</li>
				</ul>
			</div>
			<div class="right">
				<el-tabs @tab-change="tabChange" v-model="tabValue" v-if="categoryInfo.children.length">
					<el-tab-pane v-for="item in categoryInfo.children[index].children" :label="item.name" :name="item.id" />
				</el-tabs>
				<template v-if="!loading">
					<template v-if="tableData.length">
						<ul class="content-list">
							<li v-for="item in tableData" class="content-list-item">
								<div class="content-list-text"
									@click="$router.push({path:'/article-detail',query:{name:categoryInfo.name,id:item.id,open:item.comments_open}})">
									<el-icon style="margin-right: 6px;color:#8f8f8f;">
										<CaretRight />
									</el-icon>
									<a href="JavaScript:;">{{item.title.length>=20?item.title.substr(0,30)+"...":item.title}}</a>
								</div>
								<div style="color:#8f8f8f;">{{item.publish_time}}</div>
							</li>
						</ul>
						<div style="display: flex;justify-content: center;margin-top: 30px;">
							<el-pagination background layout="total,prev, pager, next" :total="params.total" :current-page="params.page"
								@current-change="currentChange" />
						</div>
					</template>
					<el-empty class="content-list" v-else description="当前暂无文章"></el-empty>
				</template>
				<el-skeleton :rows="10" animated v-else />
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		ref,
		watch,
		reactive,
		watchEffect
	} from "vue"
	import {
		useRouter,
		useRoute
	} from "vue-router"
	import {
		articleGet2
	} from "@/api/court"
	import {
		useMutitabsStore
	} from "@/store/mutitabs"

	const router = useRouter()
	const mutitabsstore = useMutitabsStore()
	const route = useRoute()

	const index = ref(0)
	const tableData = ref([])
	const categoryInfo = ref({})
	const tabValue = ref("")
	const loading = ref(false)

	const params = reactive({
		page: 1,
		total: 0,
		limit: 10,
		column: route.query.id,
		status: "published"
	})

	function initParams() {
		tableData.value = []
		params.total = 0
		params.page = 1
	}

	//二级菜单切换
	function navHandler(nav) {
		index.value = nav
		tabValue.value = categoryInfo.value.children[index.value].children[0]?.id
		if (tabValue.value) {
			params.column = categoryInfo.value.children[index.value].children[0].id
		} else {
			params.column = categoryInfo.value.children[index.value].id
		}
		params.page = 1
		initParams()
		initPage()
	}

	//三级菜单切换
	function tabChange(param) {
		params.column = param
		params.page = 1
		initPage()
	}

	//分页切换
	function currentChange(page) {
		params.page = page
		initPage()
	}

	//获取该分类下的文章列表
	function initPage() {
		//没有二级分类直接获取一级分类的文章，有三级分类获取第一个三级分类的文章
		loading.value = true
		articleGet2(params).then(res => {
			if (res.data.code == 2000) {
				res.data.data.data.map(item => {
					item.publish_time = item.publish_time.split(" ")[0]
				})
				tableData.value = res.data.data.data
				params.total = res.data.data.total
			}
			loading.value = false
		})
	}
	
	function watchHandler(){
		categoryInfo.value = JSON.parse(mutitabsstore.category)
		index.value = route.query.nav?parseInt(route.query.nav) : 0
		initParams() //从顶部点击需要将参数进行初始化
		params.column = ""
		if (categoryInfo.value.children.length != 0) { //存在二级栏目
			tabValue.value = categoryInfo.value.children[index.value].children[0]?.id
			if (tabValue.value) { //三级栏目存在吗
				params.column = categoryInfo.value.children[index.value].children[0].id
			} else {
				params.column = categoryInfo.value.children[index.value].id
			}
		} else { //不存在二级栏目即使用一级菜单
			params.column = categoryInfo.value.id
		}
		initPage()
	}

	//一级菜单监听
	watch(_ => mutitabsstore.category, watchHandler, {
		deep: true,
		immediate: true
	})
	watch(_=>route.query.nav,watchHandler)
</script>

<style lang="scss" scoped>
	.container {
		width: 1200px;
		margin: 0 auto;
		padding-top: 20px;

		.content {
			display: grid;
			grid-template-columns: 3fr 7fr;
			grid-column-gap: 30px;
			margin-bottom: 30px;
			min-height: 70vh;

			.left {
				background-color: #f2f2f2;

				.left-title {
					height: 56px;
					line-height: 56px;
					margin-bottom: 10px;
					text-align: center;
					color: #fff;
					background-color: #1764a2;
					position: relative;
					font-weight: 700;

					&:before {
						background: url(@/assets/new/flower.png) no-repeat;
						content: "";
						display: block;
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						opacity: .2;
						background-position: 0% 30%;
						background-size: 100%;
					}
				}

				.left-nav {
					margin-left: .5em;
					transition: all .5s;

					.left-nav-item {
						height: 56px;
						line-height: 56px;
						margin-bottom: 10px;
						cursor: pointer;
						font-weight: 600;
						text-align: center;
						border-left: solid 4px #cdcdcd;
						position: relative;

						&:hover {
							color: #fff;
							background-color: #409ee1;
							border-color: #1764a2;
						}

						.left-nav-flower {
							background: url(@/assets/new/flower.png) no-repeat;
							content: "";
							display: none;
							position: absolute;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
							opacity: .2;
							background-position: 0% 47%;
							background-size: 100%;
						}

						&:hover .left-nav-flower {
							display: block;
						}
					}

					.active {
						color: #fff;
						background-color: #409ee1;
						border-color: #1764a2;

						.left-nav-flower {
							display: block;
						}
					}
				}
			}

			.right {
				.content-list {
					overflow: hidden;

					.content-list-item {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height: 36px;
						overflow: hidden;
						border-bottom: 2px dotted #ddd;

						a {
							color: #000;
						}

						a:hover {
							text-decoration: none;
							color: #1764a2;
						}

						.content-list-text {
							width: 70%;
							text-wrap: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}
			}
		}
	}
</style>